var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-20 h-full w-full"},[_c('p',{staticClass:"py-3 border text-center border-oneGreen bg-oneGreen/20 text-oneGreen mb-2 font-bold px-5 rounded w-full w-[400px] m-auto"},[_vm._v(" COMMING SOON ")])])
}]

export { render, staticRenderFns }